import React from 'react';
import { connect } from 'react-redux';
import {
  makeGetIsCardMemberCard,
  makeGetAddAnEmployeeDtm,
  makeGetAddAnEmployeeUrl,
  makeGetAddAnEmployeeText
} from '../redux';

import { mapUrlWithDtmLinkQuery } from 'service_modules/models/dtm-tagging';

import { Type, Button } from '@americanexpress/aqx-components';

import styles from '../__styles__/ctas.scss?modules';

const AddAnEmployeeCta = ({
  isCardMemberCard,
  addAnEmployeeUrl,
  addAnEmployeeDtm,
  text
}) => {
  if (!isCardMemberCard) {
    return null;
  }
  const url = mapUrlWithDtmLinkQuery(addAnEmployeeUrl, addAnEmployeeDtm);
  return (
    <Button
      Component="a"
      $type={Type.Tertiary}
      href={url}
      className={styles.addAnEmployeeCta}
    >
      {text}
    </Button>
  );
};

const mapStateToProps = () => {
  const getIsCardMemberCard = makeGetIsCardMemberCard();
  const getAddAnEmployeeUrl = makeGetAddAnEmployeeUrl();
  const getAddAnEmployeeDtm = makeGetAddAnEmployeeDtm();
  const getAddAnEmployeeText = makeGetAddAnEmployeeText();

  return (state, { shortName }) => ({
    isCardMemberCard: getIsCardMemberCard(state, shortName),
    addAnEmployeeUrl: getAddAnEmployeeUrl(state, shortName),
    addAnEmployeeDtm: getAddAnEmployeeDtm(state, shortName),
    text: getAddAnEmployeeText(state)
  });
};

export default connect(mapStateToProps)(AddAnEmployeeCta);
